// extracted by mini-css-extract-plugin
export var caretAnchor = "_ub-0";
export var dropdownContent = "_ub-1";